/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Error_InaccessibleInputs */

const en_mobile_upload_error_inaccessible = /** @type {(inputs: Mobile_Upload_Error_InaccessibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't access this page or file. Check it and try again.`)
};

const es_mobile_upload_error_inaccessible = /** @type {(inputs: Mobile_Upload_Error_InaccessibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos acceder a esta página o archivo. Revísalo e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "We couldn't access this page or file. Check it and try again." |
*
* @param {Mobile_Upload_Error_InaccessibleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_error_inaccessible = /** @type {((inputs?: Mobile_Upload_Error_InaccessibleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Error_InaccessibleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_error_inaccessible(inputs)
	return en_mobile_upload_error_inaccessible(inputs)
});